import { render, staticRenderFns } from "./ButtonIcon.vue?vue&type=template&id=04acf4b4&scoped=true&lang=pug&"
import script from "./ButtonIcon.vue?vue&type=script&lang=js&"
export * from "./ButtonIcon.vue?vue&type=script&lang=js&"
import style0 from "./ButtonIcon.vue?vue&type=style&index=0&id=04acf4b4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04acf4b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
